import type { VoucherCopy } from '@voll-intelligence/intelligence-ui-kit';
import { t } from './i18n.js';

/** The chrome copy of the kit's voucher documents in the host's locale (#5001): the web-chat
 *  drawers and the web console draw the same documents, so the words live here once. */
export function voucherCopy(): VoucherCopy {
  return {
    copied: t('voucherDoc.copied'),
    copyFailed: t('voucherDoc.copyFailed'),
    copyWhat: (what) => t('voucherDoc.copy', { what }),
    copyFallback: t('voucherDoc.copyFallback'),
    copyValue: (value) => t('voucherDoc.copyAria', { value }),
    close: t('voucherDoc.close'),
    closeSr: t('voucherDoc.closeSr'),
    back: t('flightVoucher.back'),
    moreInfo: t('voucherDoc.moreInfo'),
    total: t('voucherDoc.total'),
    talk: t('voucherDoc.talk'),
    talkTooltip: t('voucherDoc.talkTooltip'),
    share: t('voucherDoc.share'),
    shareTooltip: t('voucherDoc.shareTooltip'),
    moveToTrip: t('voucherDoc.moveToTrip'),
    newRequest: t('voucherDoc.newRequest'),
    cancel: t('voucherDoc.cancel'),
    cancelTooltip: t('voucherDoc.cancelTooltip'),
    more: t('flightVoucher.more'),
    email: t('flightVoucher.email'),
    cancelBy: {
      booking: t('flightVoucher.cancelBooking'),
      request: t('flightVoucher.cancelRequest'),
      baggage: t('flightVoucher.cancelBaggage'),
      seat: t('flightVoucher.cancelSeat'),
    },
    status: (label) => t('voucherSkeleton.status', { label }),
    values: t('voucherSkeleton.values'),
    request: t('voucherSkeleton.request'),
    stopDetails: t('flightVoucher.stopDetails'),
    fareRules: t('flightVoucher.fareRules'),
    locator: t('flightVoucher.locator'),
    allowance: {
      title: t('flightVoucher.allowance.title'),
      included: t('flightVoucher.allowance.included'),
      notIncluded: t('flightVoucher.allowance.notIncluded'),
      unknown: t('flightVoucher.allowance.unknown'),
      add: t('flightVoucher.allowance.add'),
      noneTitle: t('flightVoucher.allowance.noneTitle'),
      noneText: t('flightVoucher.allowance.noneText'),
      estimated: t('flightVoucher.allowance.estimated'),
    },
  };
}
